import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M2 5.176v6.829C2 12 2 12 2.007 12h11.986l.007-.001V6.5h2v5.499C16 13.106 15.1 14 13.993 14H2.007A2 2 0 010 12.005v-8.01C0 2.9.903 2 2.007 2h11.986c1.493 0 2.024 1.46.864 2.408l-6.852 5.593L2 5.176zM3.73 4l4.265 3.427L12.194 4H3.73z',
    ],
    24: [
        'M4 7.329v10.664C4 18 4 18 3.993 18h16.014H20V9h2v9.005A2 2 0 0120.007 20H3.993A2 2 0 012 17.993V6.007A2 2 0 013.993 4h16.014c1.478 0 2 1.443.906 2.416l-7.497 6.663c-.787.7-2.032.71-2.827.015L4 7.329zM5.519 6l6.387 5.589c.033.029.145.028.181-.005L18.37 6H5.519z',
    ],
};
const IconEmail = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconEmail.displayName = 'IconEmail';

export { IconEmail };
//# sourceMappingURL=IconEmail.js.map
